import { render, staticRenderFns } from "./consumption-donut-chart.vue?vue&type=template&id=c05812a4&scoped=true"
import script from "./consumption-donut-chart.vue?vue&type=script&lang=js"
export * from "./consumption-donut-chart.vue?vue&type=script&lang=js"
import style0 from "./consumption-donut-chart.vue?vue&type=style&index=0&id=c05812a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05812a4",
  null
  
)

export default component.exports